import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

// Custom dropdown menu, in the same spirit as the profile button's menu
// (reuses .profile-menu). Rendered in a portal (position: fixed) so it is not
// clipped by the scrolling settings container.
// options: [{ value, label }]
function Dropdown({ value, options, onChange, disabled, ariaLabel }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (btnRef.current && btnRef.current.contains(e.target)) return;
      if (menuRef.current && menuRef.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  const toggle = () => {
    if (disabled) return;
    if (!open && btnRef.current) {
      const r = btnRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 6, left: r.left, width: r.width });
    }
    setOpen(o => !o);
  };

  const current = options.find(o => o.value === value);

  return (
    <div class="gl-dropdown">
      <button type="button" ref={btnRef} class={`gl-dropdown-trigger${open ? " open" : ""}`}
        disabled={disabled} onClick={toggle}
        aria-haspopup="listbox" aria-expanded={open} aria-label={ariaLabel}>
        <span class="gl-dropdown-value">{current ? current.label : "—"}</span>
        <svg class="gl-dropdown-caret" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
          <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      {open && ReactDOM.createPortal(
        <div class="profile-menu gl-dropdown-menu" role="listbox" ref={menuRef}
          style={{ top: `${pos.top}px`, left: `${pos.left}px`, minWidth: `${pos.width}px` }}>
          {options.map(o => (
            <button key={o.value} type="button" role="option" aria-selected={o.value === value}
              class={`profile-menu-item${o.value === value ? " active" : ""}`}
              onClick={() => { onChange(o.value); setOpen(false); }}>
              {o.label}
            </button>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
}

export default Dropdown;
